import { Alert, Button, Modal } from "../../ds";

// Bedienelemente rund um den lokalen Regel-Entwurf der Firewall-Sektion:
// Kopfzeile und Sicherheitsabfrage vor dem Schreiben. Implementierungsdetail
// von FirewallSection.

/** Frist des Agents, bis er ohne Bestätigung zurückrollt. */
export const REVERT_IN = 90;

/** Kopfzeile der Sektion: Entwurf verwerfen, anwenden. Angelegt wird je Liste
 *  in ihrer eigenen Karte — dort steht auch, was „neu" dann bedeutet. */
export function DraftToolbar({
  dirty,
  applyDisabled,
  applying,
  onDiscard,
  onApply,
}: {
  dirty: boolean;
  applyDisabled: boolean;
  applying: boolean;
  onDiscard: () => void;
  onApply: () => void;
}) {
  return (
    <>
      {dirty && (
        <Button size="sm" variant="ghost" iconName="close" onClick={onDiscard}>
          Verwerfen
        </Button>
      )}
      <Button
        size="sm"
        variant="primary"
        iconName="check"
        disabled={applyDisabled}
        loading={applying}
        onClick={onApply}
      >
        Anwenden
      </Button>
    </>
  );
}

export function ApplyConfirmModal({
  open,
  entryCount,
  busy,
  onClose,
  onApply,
}: {
  open: boolean;
  entryCount: number;
  busy: boolean;
  onClose: () => void;
  onApply: () => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Firewall-Konfiguration anwenden?"
      size="sm"
      actions={
        <>
          <Button variant="ghost" onClick={onClose}>
            Abbrechen
          </Button>
          <Button variant="danger" iconName="shield" loading={busy} onClick={onApply}>
            Auf Probe anwenden
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3 text-sm">
        <Alert variant="danger" title="Eine kaputte Regel bedeutet eine Vor-Ort-Fahrt">
          Der Router steht an einem entfernten Standort und hängt an einer LTE-SIM. Sperren die
          Regeln das LAN oder den WAN-Zugang aus, ist er nicht mehr fernwartbar.
        </Alert>
        <p className="text-content-2">
          Deshalb wird zuerst nur <strong>auf Probe</strong> angewendet: Der Router sichert die alte
          Konfiguration und stellt sie nach {REVERT_IN} Sekunden automatisch wieder her — es sei
          denn, du bestätigst vorher mit „Behalten“.
        </p>
        <p className="text-content-2">
          Es werden {entryCount} Einträge geschrieben (Port-Freigaben, Regeln, Zonen und
          Weiterleitungen zusammen).
        </p>
      </div>
    </Modal>
  );
}
